import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import Logo from 'src/components/logo';

export default function AuthClassicLayout({ children }) {
  const upMd = useResponsive('up', 'md');

  const renderLogo = <Logo isFull sx={{ position: 'absolute', m: { xs: 2, md: 5 } }} />;

  const renderContent = (
    <Stack
      sx={{
        width: 1,
        mx: 'auto',
        maxWidth: 480,
        px: { xs: 2, md: 8 },
        py: { xs: 15, md: 30 },
      }}
    >
      {children}
    </Stack>
  );

  const renderSection = (
    <Stack
      flexGrow={1}
      alignItems="center"
      spacing={10}
      sx={{ backgroundColor: 'background.paper', pt: 10 }}
    >
      <Typography variant="h3" sx={{ maxWidth: 480, textAlign: 'center' }}>
        Setanta Sports Middleware
      </Typography>

      <Box sx={{ borderRadius: 2, p: 2, border: '2px solid', borderColor: 'divider' }}>
        <Box
          sx={{ borderRadius: 2, boxShadow: 3 }}
          component="img"
          alt="auth"
          src="/assets/illustrations/illustration_dashboard.png"
        />
      </Box>
    </Stack>
  );

  return (
    <Stack component="main" direction="row" sx={{ minHeight: '100vh' }}>
      {renderLogo}
      {renderContent}

      {upMd && renderSection}
    </Stack>
  );
}

AuthClassicLayout.propTypes = {
  children: PropTypes.node,
};
